import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import { AdminClinicsAddPage } from "../admin-clinics-add/admin-clinics-add";
import { PatientsPage } from "../patients/patients";
import { Storage } from "@ionic/storage";
import { AdminPrescriptionsPage } from "../admin-prescriptions/admin-prescriptions";
import {AdminOrdersPage} from "../admin-orders/admin-orders";

@IonicPage()
@Component({
  selector: "page-admin-clinics",
  templateUrl: "admin-clinics.html"
})
export class AdminClinicsPage {

  public clinicList: Observable<any[]>;
  public nursingHomeList: any[];
  clinic_name: string;
  clinic_id: string;
  user: any;
  clinic: any = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private storage: Storage
  ) {
    this.auth.getCurrentUser().then(user => {
      this.user = user;
      
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.clinicList = this.database
      .getClinics()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })

      this.database
      .getNursingHomes()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .subscribe(nh => {
        this.nursingHomeList = nh;
      })
    });
  }

  switchClinic(selected_clinic)  {
    let confirm = this.alertCtrl.create({
      title: "Switch Clinic?",
      message: "Are you sure you want to switch to viewing " + selected_clinic.clinic_name + "?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't switch clinic right now");
          }
        },
        {
          text: "Yes",
          handler: () => {
            let user: any = {};
            user.clinic_id = selected_clinic.id;
            user.clinic_name = selected_clinic.clinic_name;
            user.clinic_province = selected_clinic.address.province;

            console.log('Switching clinic: ', this.user.id, user);
            this.database.updateUserClinic(this.user.id, user).then((data) => {
              this.storage.remove('RetinaOrderBatch').then(() => {
                if(this.user.roles.retina_pharmacist)  {
                  this.navCtrl.setRoot(AdminPrescriptionsPage)
                } else if(this.user.roles.retina_reporting){
                  this.navCtrl.setRoot(AdminClinicsPage)
                } else {
                  this.navCtrl.setRoot(PatientsPage)
                }
              });
            })
            .catch((err) => {
              console.log(err)
            })
          }
        }
      ]
    });
    confirm.present();
  }

  presentAddClinicModal() {
    let clinicModal = this.modalCtrl.create(AdminClinicsAddPage, {showBackdrop: true, enableBackdropDismiss: false});
    clinicModal.present();
  }

  editClinic(clinic)  {
    let clinicModal = this.modalCtrl.create(AdminClinicsAddPage, {'clinicdata': clinic} , {showBackdrop: true, enableBackdropDismiss: false});
    clinicModal.present();
  }

  checkNursingHomes() {
    this.clinicList.subscribe(clinics => {
      clinics.forEach((clinic) => {
        this.database.getDoctorsByClinic(clinic.id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        })
        .subscribe(doctors => {
          doctors.forEach(async doctor => {
            if (clinic.locations.length > 0) {
              console.log('Clinic with locations: ', clinic.locations.length, clinic.clinic_name, doctor.first_name + ' ' + doctor.last_name);
              const start = async () => {
                await clinic.locations.forEach(async (location) => {
                  const nh = this.nursingHomeList.find((nh) => nh.clinic_id === clinic.id && nh.location === location.name && nh.doctor_id === doctor.id)
                  if (!nh) {
                    console.log("Creating: ", clinic.clinic_name, location.name, doctor.first_name + ' ' + doctor.last_name);
                    const newNursingHome: any = {
                      clinic_id: clinic.id,
                      clinic_name: clinic.clinic_name,
                      doctor_id: doctor.id,
                      doctor_name: doctor.first_name + ' ' + doctor.last_name,
                      location: location.name,
                      createdAt: this.database.timestamp,
                      in_kroll: false
                    };
                    await this.database.createNursingHome(newNursingHome);
                  }
                })
              }
              start();
            } else {
              console.log('Clinic with no locations: ', clinic.clinic_name, doctor.first_name + ' ' + doctor.last_name);
              const nh = this.nursingHomeList.find((nh) => nh.clinic_id === clinic.id && nh.location === clinic.clinic_name && nh.doctor_id === doctor.id)
              if (!nh) {
                console.log("Creating: ", clinic.clinic_name, doctor.first_name + ' ' + doctor.last_name);
                const newNursingHome: any = {
                  clinic_id: clinic.id,
                  clinic_name: clinic.clinic_name,
                  doctor_id: doctor.id,
                  doctor_name: doctor.first_name + ' ' + doctor.last_name,
                  location: clinic.clinic_name,
                  createdAt: this.database.timestamp,
                  in_kroll: false
                };
                await this.database.createNursingHome(newNursingHome);
              }
            }
          })
        })
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-clinics/admin-clinics.ts